<template>
  <div class="personalCenter">
    <!-- <H2>我的钱包/观看历史/收藏记录公共头部</H2> start-->
    <div class="purse-header" v-if="actType != '4' && actType != '13' && actType != '14'">
      <div class="header-left">
        <img  @dragstart.prevent  src="../../assets/touxiang.png" alt="">
        <!-- <span>{{userInfo.nickname}}</span> -->
         <span>游客8675468</span>
        <span v-if="userInfo.vip && Number(money)>0" style="margin-left:3px;font-size: 18px;" > - {{money}} 看币</span>
      </div>
      <!-- 有会员区分 -->
      <p v-if='userInfo.vip'>会员截止时间：{{userInfo.vipEndDate}}</p>
      <p v-else class="balance"><span>余额：</span><span>{{money}} 看币</span></p>
    </div>
    <!-- <H2>我的钱包/观看历史/收藏记录公共头部</H2> end-->


    <!-- 我的钱包：24  观看历史：22  收藏记录：23  交易记录:4  关于我们13 联系我们14  start-->
    <!-- 我的钱包 -->
    <div v-if='actType == "24"' name="wdqb">
      <div class="purse-vip">
        <p>充值</p>
        <div class="vip-left">
          <img  @dragstart.prevent  src="../../assets/icon_zhifubao.png" alt="">
          <span class="vip-text">支付宝支付</span>
        </div>
      </div>
      <div class="purse-tempList">
        <div
          :class="[(index + 1) % 3 == 0 ? 'item-noMargin' : '', (item.id == purActive) ? 'vitem-act' : '', 'vtemp-item',]"
          @click="changePurse(item.id)" v-for="(item, index) in purseTempList" :key="item.id">
          <p>￥{{ item.price }}元</p>
          <p v-if="item.cueWords">{{ item.type == 2 ? `${item.cueWords}看币`: item.cueWords }}</p>
          <p v-if="item.label && item.tupe == 1">{{item.label}}</p>
          <p v-if="item.corner">{{ item.corner }}</p>
        </div>
      </div>
      <div class="purse-btn cursorPointer" @click="payOrder">
        点击充值
      </div>
      <div class="shuomingTit">充值说明</div>
      <p class="shuomingCon">
        1.购买会员后可免费观看漫画至会员日期结束。<br/>
        2.看币的兑换比例：1元=100看币<br/> 
        3.不支持未成年人购买，不支持退款。<br/>
        4.充值后可能有延迟的情况，1小时内未到账请联系客服：15840721070，客服工作时间：9:00-18:00。<br/>
        5.充值会员，仅限本站站内使用，不能提现，不能转赠。<br/>
      </p>
    </div>
    <!-- 观看历史  &  收藏记录-->
    <div v-if='actType == "22" || actType == "23"' :name="actType == '22' ? 'gkls' : actType == '23' ? 'scjz' : ''" style="margin: 30px 0 0 10px; max-height:800px; overflow-y: auto;">
      <cover-page-list v-if="dataList.length>0" :dataList="dataList" :num="num" :type="actType == '22' ? 'gkls' : actType == '23' ? 'scjz' : ''" ></cover-page-list>
      <nothing-con v-else></nothing-con>
    </div>
    <!-- 交易记录 -->
    <div v-if='actType == "4"' name="jyjl" style="margin: 8px 0 0 0px;" class="trade">
      <!-- 选项卡区域 -->
      <div style="margin-bottom: 30px;">
        <span :class="index == tactive ? 'active trade-option' : 'trade-option'" v-for="(item, index) in tradeList"
          :key="item.id" @click="jyjlGetList(index)"> {{ item.name }}</span>
      </div>
      <!-- 内容 -->
      <div class="trade-con">
          <div v-if="tactive == 0 && tradecon[tactive].list.length>0">
              <div v-for="(item, index) in tradecon[tactive].list" :key="index" :class="[index == tradecon[tactive].list.length - 1 ? 'noborder' : '', 'trade-item']">
                <div class="con-left">
                  <p>￥{{ item.discount }}元</p>
                  <p>{{ item.type == 1 ? item.corner+'全站免费看' :item.amount+'看币' }}</p>
                </div>
                <p class="con-right">{{ item.payTime }}</p>
              </div>
              <p class="nomarl">暂无更多记录~</p>
          </div>
          <nothing-con v-if="tactive == 0 && tradecon[tactive].list.length==0"></nothing-con>
          <div v-if="tactive == 1 && tradecon[tactive].list.length>0">
            <div v-for="(item, index) in tradecon[tactive].list" :key="index" :class="[index == tradecon[tactive].list.length - 1 ? 'noborder' : '', 'trade-item']">
              <div class="con-left">
                <p>{{ item.comicName }}</p>
                <p>第{{ item.chapterNumber ? item.chapterNumber : 1 }}话</p>
              </div>
              <div class="con-right">
                <!-- 0vip  1看点 -->
                <p class="kanbi" v-if="item.type == 1">{{ item.quantity }}看币</p>
                <p>{{ item.ctime }}</p>
              </div>
            </div>
            <p class="nomarl">暂无更多记录~</p>
          </div>
          <nothing-con v-if="tactive == 1 && tradecon[tactive].list.length==0"></nothing-con>
      </div>
    </div>
    <!-- 关于我们 -->
    <div v-if='actType == "13"' name="gywm">
      <div class="aboutUs">
        <!-- <div class="header"><img  @dragstart.prevent  src="../../assets/about_logo.png" alt=""></div>
        <p class="con1">太原巴卡巴科技</p> -->
        <p class="con2">
          太原巴卡巴科技有限公司是一家专注于数字内容创作与分发的科技公司，致力于为用户提供高质量的漫剧和短剧内容。
        </p>
        <p class="con2">
          我们拥有一支经验丰富的团队，在内容创作、技术开发和运营推广方面具有深深的积累。通过不断创新和优化，我们致力于打造行业领先的数字内容平台，为用户带来更加丰富多样的娱乐体验。
        </p>
        <p class="con2">
          公司始终坚持以用户为中心，以内容质量为核心竞争力，不断推出符合市场需求的优质产品，赢得了广大用户的认可和信赖。
        </p>
      </div>
    </div>
    <!-- 联系我们 -->
    <div v-if='actType == "14"' name="lxwm">
      <div class="contactUs">
        <!-- <div class="header"><img  @dragstart.prevent  src="../../assets/wxkefu.jpg" alt=""></div>
        <p class="con1">太原巴卡巴科技</p> -->
        <p class="con2">
          客服电话:15840721070<br>
          联系邮箱:13121557965@163.com<br>
          客服工作时间:上午10:00-12:00下午13:00-19:00<br>
        </p>
      </div>
    </div>
    <!-- // 我的钱包：24  观看历史：22  收藏记录：23  交易记录:4  关于我们13    end-->

  </div>
</template>
  
<script setup>
import Cookies from 'js-cookie'
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from 'vue-router'
// import vfourList from '../components/vfourList.vue'
import coverPageList from '../../components/coverPageList.vue'
import nothingCon from '../../components/nothingCon.vue'
import {gearGet, comiCorderCreate, orderFind, rechargeFind, rechargeRemain, recentRead, enjoyRead, unlockList, useInfoApi} from '@/utils/api'
import { getUserInfo, payMoneyPublic } from '@/utils/utils'
let route = useRoute()
let purseTempList = ref([])
let purActive = ref(0)
let money = ref(0)
let userInfo = ref({
  nickname:'',
  vip:false,
  vipEndDate:''
})
let orderSn = ref(0)
let resData = ref({})
let dataList = ref([])
let actType = ref(route.query.id ? route.query.id : 24)
let num = ref(4)
let tactive = ref(0)
//交易
let tradeList = ref([{ name: '充值记录' }, { name: '消费记录' }])
let tradecon = ref([ {list: [],}, { list: [],}])
watch(() => route.query,
  (val) => {
     // 我的钱包：24  观看历史：22  收藏记录：23  交易记录:4  关于我们13
    actType.value = val.id;
    refresh(val.id)
  })
onMounted(()=>{
  refresh(actType.value)
})
let refresh = (val)=>{
  if(val == "24"){
    gearGetList()
  }else{
    userInfo.value = getUserInfo()
    val == "23" || val == "22" ? getListByType(val) : ''
    val == "4" ? jyjlGetList(0) : ''
  }
  if(val == "24" || val == "23" || val == "22"){
    rechargeRemain().then(res=>{
      money.value = res.data.remain
    })
  }
}
let gearGetList = (()=> {
  purseTempList.value = [ {
    id:1,
           type:1,
          price:1,
          cueWords:'3天会员免费看',
          label:'三天会员免费看',
          corner:'新用户专享'
        },
      {
         id:2,
        type:2,
          price:13,
          cueWords:1300,
          label:'111',
          corner:''
        },
      {
         id:3,
        type:2,
          price:19,
          cueWords:190,
          label:'111',
          corner:''
        },
      {
         id:4,
        type:2,
          price:15.4,
          cueWords:154,
          label:'111',
          corner:''
        },
      {
         id:5,
        type:2,
          price:12.5,
          cueWords:125,
          label:'111',
          corner:''
        }]
        return false
  useInfoApi().then((res)=>{
    localStorage.setItem('info',JSON.stringify(res.data))
    userInfo.value = res.data
  })
  gearGet().then(res=>{
    let list = res.data
    for (let item in list){
      if(list[item].type == 2){
        list[item].cueWords = (Number(list[item].price) *100).toFixed(0)
      }
    }
    // purseTempList.value = res.data
    
    purActive.value = res.data[0].id
  })
})
let getListByType = (type => {
  let query = {
    pageNum: 1,
    pageSize: 1000,
  }
  if(type == '23'){
    enjoyRead(query).then(res=>{
      dataList.value = res.data.records
    })
  }else if(type == '22'){
    recentRead(query).then(res=>{
      dataList.value = res.data.records
    })
  }
})
let jyjlGetList = (index)=>{
  tactive.value = index
  let query = {
    pageNum: 1,
    pageSize: 1000,
  }
  if(index == 0){
    // 查询充值记录
    rechargeFind().then(res=>{
      tradecon.value[0].list = res.data
    })
  }else{
    unlockList().then(res=>{
      tradecon.value[1].list = res.data
    })
  }
}
let payOrder = ()=>{ //支付宝支付
  alert('功能开发中,请持续关注...')
    // payMoneyPublic(purActive.value,`/personal/personalComponents/personalCenter?id=${actType.value}`)
}
let changePurse = (ind => {
  purActive.value = ind
})








let isVIP = ref(true)








let handleAct = (index => {
})


</script>
  
<style lang="scss" scoped>
.personalCenter {
  padding: 20px;
  box-sizing: border-box;

  .purse-header {
    // width: 918px;
    height: 90px;
    background: rgba(203, 41, 69, 0.06);
    border-radius: 10px;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        width: 56px;
        height: 56px;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 10px;
      }

    }

    .balance {
      span:nth-child(1) {
        font-size: 18px;
        color: #333333;
        line-height: 24px;
      }

      span:nth-child(2) {
        font-size: 18px;
        color: #CB2945;
        line-height: 24px;
      }
    }
  }

  .purse-vip {
    width: 918px;
    height: 90px;
    // background: red;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    font-family: PingFangSC, PingFang SC;
    
    color: #333333;
    line-height: 40px;

    .vip-left {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        width: 26px;
        height: 26px;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 10px;
      }

      .vip-text {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;font-weight: lighter;
        color: #333333;
        line-height: 22px;
      }
    }
  }

  .purse-tempList {
    // background-color: lawngreen;
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px;
    .vtemp-item {
      width: 280px;
      height: 140px;
      border-radius: 10px;
      margin: 0 18px 30px 0;
      padding: 14px 20px 19px;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      background: #FFFFFF;
      border: 2px solid #E6E6E6;

      p:nth-child(1) {
        font-size: 22px;
        
        color: #CB2945;
        line-height: 30px;
      }

      p:nth-child(2) {
        font-size: 14px;
        font-weight: 400;font-weight: lighter;
        color: #CB2945;
        line-height: 20px;
        margin: 12px 0 20px;

      }

      p:nth-child(3) {
        // width: 90px;
        // height: 30px;
        background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
        border-radius: 19px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;font-weight: lighter;
        color: #FFFFFF;
        display: inline-block;
        padding: 0px 17px;
      }

      p:nth-child(4) {
        height: 30px;
        padding: 5px 15px 5px 23px;
        box-sizing: border-box;
        background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
        border-radius: 100px 0px 0px 100px;
        font-size: 14px;
        font-weight: 400;font-weight: lighter;
        color: #FFFFFF;
        line-height: 20px;
        position: absolute;
        top: 10px;
        right: 0;
      }
    }

    .vitem-act {
      background: rgba(203, 41, 69, 0.06);
      border: 2px solid #CB2945;

    }

    .item-noMargin {
      margin-right: 0;
    }
  }

  .purse-btn {
    width: 248px;
    height: 42px;
    background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
    border-radius: 21px;
    margin: auto;
    font-size: 20px;
    
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    line-height: 42px;
    margin-bottom: 30px;
  }
  .shuomingTit{
    font-size: 22px;
    
    color: #333333;
    line-height: 30px;
    margin-bottom: 20px;
    padding: 0 20px;
  }
  .shuomingCon{
    font-size: 16px;
    color: #666666;
    line-height: 28px;
    padding: 0 20px;
  }

  .trade {
    .trade-option {
      font-size: 20px;
      font-weight: 400;font-weight: lighter;
      color: #666666;
      line-height: 28px;
      margin-right: 33px;
      cursor: pointer;
    }

    .active {
      font-size: 28px;
      
      color: #333333;
      line-height: 40px;
    }

    .trade-con {
      width: 898px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 2px solid #E6E6E6;
      padding: 30px 30px 0;
      box-sizing: border-box;
      max-height: 480px; 
      overflow-y: auto;
      .trade-item {
        // background-color:lightgreen;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px 30px;
        border-bottom: 1px dashed #E6E6E6;
        margin-bottom: 30px;
      }

      .noborder {
        border-bottom: none;
      }

      .active-con {
        display: block;
      }

      .none-con {
        display: none;
      }

      .con-left {
        p:nth-child(1) {
          font-size: 20px;
          
          color: #333333;
          line-height: 24px;
          margin-bottom: 10px;
          text-overflow:ellipsis;
        }

        p:nth-child(2) {
          font-size: 16px;
          font-weight: 400;font-weight: lighter;
          color: #666666;
          line-height: 22px;
        }
      }

      .con-right {
        font-size: 16px;
        font-weight: 400;font-weight: lighter;
        color: #666666;
        line-height: 24px;
        text-align:center;
        .kanbi {
          font-size: 20px;
          
          color: #333333;
          line-height: 24px;
          margin-bottom: 10px;
        }
      }

    }

    .nomarl {
      margin: 20px 0 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;font-weight: lighter;
      color: #666666;
      line-height: 22px;
    }
  }

  .aboutUs {
    padding: 50px 40px;
    box-sizing: border-box;
    text-align: center;
    color: #333333;

    .header {
      width: 80px;
      height: 80px;
      margin: auto;

      img {
        width: 80px;
        height: 80px;
      }
    }

    .con1 {
      font-size: 20px;
      
      line-height: 28px;
      margin: 34px 0 64px 0;

    }

    .con2 {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      line-height: 36px;
      text-align: left;
    }

  }

  .contactUs {
    padding: 50px 40px;
    box-sizing: border-box;
    text-align: center;
    color: #333333;

    .header {
      width: 160px;
      height: 160px;
      margin: auto;

      img {
        width: 160px;
        height: 160px;
      }
    }

    .con1 {
      font-size: 20px;
      
      line-height: 28px;
      margin: 34px 0 64px 0;

    }

    .con2 {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      line-height: 36px;
    }

  }
}
</style>
  